import { getUserFromToken, getUserStatus, mapRetailersToSort } from 'utils';

import { commonStore } from './commonStore';
import { ICommonStoreActions } from './types';

export const loginAction: ICommonStoreActions['loginAction'] = (data) => {
  const { idToken, accessToken } = data;

  const user = getUserFromToken(idToken);
  const isSessionExpired = getUserStatus(user);

  commonStore.setState({
    user,
    idToken,
    accessToken,
    isSessionExpired,
  });
};

export const initRetailersAction: ICommonStoreActions['initRetailersAction'] = (data) => {
  const { merchants } = data;

  const retailers = mapRetailersToSort(merchants);

  commonStore.setState({
    retailers,
    isRefetchCommonData: false,
  });
};

export const checkSessionAction: ICommonStoreActions['checkSessionAction'] = () => {
  commonStore.setState((state) => {
    const isSessionExpired = getUserStatus(state.user);

    return {
      isSessionExpired,
    };
  });
};

export const refetchCommonData: ICommonStoreActions['refetchCommonData'] = () => {
  commonStore.setState({
    isRefetchCommonData: true,
  });
};
